<template>
  <b-modal
    id="comparison-modal"
    ref="modal"
    :hide-footer="true"
    @hidden="onModalHidden"
    content-class="rounded-0"
    body-class="pb-4"
  >
    <div slot="modal-title">
      <span class="survey-results__card_title">{{ modalTitle }}</span>
    </div>
    <div class="v2_color_primary_teal v2_font_weight_semibold v2_font_size_18">
      Report name:
    </div>
    <div role="group" class="my-2">
      <b-form-input
        type="text"
        v-model="$v.title.$model"
        placeholder="Enter Report Name"
        :state="validateState('title')"
        class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
      />
      <b-form-invalid-feedback>
        {{ titleInvalidFeedback }}
      </b-form-invalid-feedback>
    </div>
    <b-button
      size="sm"
      class="mt-2 px-4"
      variant="v2_white"
      @click="$refs.modal.hide(true)"
    >
      Cancel
    </b-button>
    <b-button
      size="sm"
      class="float-right mt-2 px-4"
      @click="onSave"
      variant="v2_primary"
    >
      {{ saveButtonTitle }}
    </b-button>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'CreateComparisonModal',
  mixins: [validationMixin],
  props: {
    initialTitle: {
      type: [String, null],
      default: null,
    },
    isEditType: {
      type: [Boolean],
      default: false,
    },
    comparisonTitles: {
      type: [Array],
      default() {
        return [];
      },
    },
  },
  data: function () {
    return {
      title: this.initialTitle || '',
    };
  },
  validations: {
    title: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
      isUnique(value) {
        return !this.comparisonTitles.find((c) => c === value);
      },
    },
  },
  mounted: function () {
    this.showModal();
  },
  computed: {
    modalTitle: function () {
      return this.isEditType ? 'Rename Report' : 'Create Report';
    },
    saveButtonTitle: function () {
      return this.isEditType ? 'Save' : 'Create';
    },
    titleInvalidFeedback: function () {
      if (!this.$v.title.maxLength) {
        return "Title can't be more than 255 characters.";
      }
      if (!this.$v.title.minLength) {
        return "Title can't be less than 2 characters.";
      }
      if (!this.$v.title.isUnique) {
        return 'Comparison with the same Title already exists.';
      }

      return 'This field is required';
    },
  },
  methods: {
    showModal: function () {
      this.$refs.modal.show();
    },
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSave: function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.$emit('modalSave', this.title);
    },
    onModalHidden: function () {
      this.$emit('modalCancel');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables_mixins.scss';
.input-label {
  @include phairify_body_copy;
  font-weight: bold;
  color: $phairify_primary_color_teal;
}
</style>
